module.exports = __webpack_public_path__ + "static/img/member.c97c830b.png";